import { createSelector } from "@reduxjs/toolkit"
import { IState } from "../.."

const navigationState = (state: IState) => state.navigation
export const selectNavigation = createSelector(navigationState, (state) => state.items)
